import { UUID } from "@opendaw/lib-std";
export var TemplatePaths;
(function (TemplatePaths) {
    TemplatePaths.Folder = "templates/v1";
    TemplatePaths.ProjectFile = "project.od";
    TemplatePaths.ProjectMetaFile = "meta.json";
    TemplatePaths.ProjectCoverFile = "image.bin";
    TemplatePaths.projectFile = (uuid) => `${(TemplatePaths.templateFolder(uuid))}/${TemplatePaths.ProjectFile}`;
    TemplatePaths.projectMeta = (uuid) => `${(TemplatePaths.templateFolder(uuid))}/${TemplatePaths.ProjectMetaFile}`;
    TemplatePaths.projectCover = (uuid) => `${(TemplatePaths.templateFolder(uuid))}/${TemplatePaths.ProjectCoverFile}`;
    TemplatePaths.templateFolder = (uuid) => `${TemplatePaths.Folder}/${UUID.toString(uuid)}`;
})(TemplatePaths || (TemplatePaths = {}));
